var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 250,
    zoomAndPan: "magnify",
    viewBox: "0 0 187.5 60",
    height: 80,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("g", null))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#ff00ff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.364679, 27.12578)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 15.773438 0 L 15.773438 -4.566406 L 5.796875 -4.566406 L 5.796875 -20.039062 L 0.78125 -20.039062 L 0.78125 0 Z M 15.773438 0 "
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#ff00ff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.737181, 27.12578)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 5.796875 0 L 5.796875 -20.039062 L 0.78125 -20.039062 L 0.78125 0 Z M 5.796875 0 "
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#ff00ff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(24.316222, 27.12578)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 15.652344 0 L 15.652344 -4.566406 L 6.367188 -4.566406 L 15.652344 -16.101562 L 15.652344 -20.039062 L 0.601562 -20.039062 L 0.601562 -15.441406 L 9.972656 -15.441406 L 0.601562 -3.875 L 0.601562 0 Z M 15.652344 0 "
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fill: "#ff00ff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(40.56856, 27.12578)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 15.652344 0 L 15.652344 -4.566406 L 6.367188 -4.566406 L 15.652344 -16.101562 L 15.652344 -20.039062 L 0.601562 -20.039062 L 0.601562 -15.441406 L 9.972656 -15.441406 L 0.601562 -3.875 L 0.601562 0 Z M 15.652344 0 "
  }))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    fill: "#ff00ff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(56.820902, 27.12578)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 16.460938 -15.441406 L 16.460938 -20.039062 L 10.453125 -20.039062 L 10.453125 -12.316406 L 6.457031 -12.316406 L 6.457031 -20.039062 L 0.449219 -20.039062 L 0.449219 -15.441406 L 1.441406 -15.441406 L 1.441406 -7.902344 L 5.949219 -7.902344 L 5.949219 0 L 10.964844 0 L 10.964844 -7.902344 L 15.472656 -7.902344 L 15.472656 -15.441406 Z M 16.460938 -15.441406 "
  }))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    fill: "#00ffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.203137, 26.004093)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 15.773438 0 L 15.773438 -4.566406 L 5.796875 -4.566406 L 5.796875 -20.039062 L 0.78125 -20.039062 L 0.78125 0 Z M 15.773438 0 "
  }))))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    fill: "#00ffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.57564, 26.004093)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 5.796875 0 L 5.796875 -20.039062 L 0.78125 -20.039062 L 0.78125 0 Z M 5.796875 0 "
  }))))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    fill: "#00ffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(23.15468, 26.004093)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 15.652344 0 L 15.652344 -4.566406 L 6.367188 -4.566406 L 15.652344 -16.101562 L 15.652344 -20.039062 L 0.601562 -20.039062 L 0.601562 -15.441406 L 9.972656 -15.441406 L 0.601562 -3.875 L 0.601562 0 Z M 15.652344 0 "
  }))))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    fill: "#00ffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(39.407019, 26.004093)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 15.652344 0 L 15.652344 -4.566406 L 6.367188 -4.566406 L 15.652344 -16.101562 L 15.652344 -20.039062 L 0.601562 -20.039062 L 0.601562 -15.441406 L 9.972656 -15.441406 L 0.601562 -3.875 L 0.601562 0 Z M 15.652344 0 "
  }))))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    fill: "#00ffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(55.659361, 26.004093)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 16.460938 -15.441406 L 16.460938 -20.039062 L 10.453125 -20.039062 L 10.453125 -12.316406 L 6.457031 -12.316406 L 6.457031 -20.039062 L 0.449219 -20.039062 L 0.449219 -15.441406 L 1.441406 -15.441406 L 1.441406 -7.902344 L 5.949219 -7.902344 L 5.949219 0 L 10.964844 0 L 10.964844 -7.902344 L 15.472656 -7.902344 L 15.472656 -15.441406 Z M 16.460938 -15.441406 "
  }))))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    fill: "#18307b",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.783908, 26.564936)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 15.773438 0 L 15.773438 -4.566406 L 5.796875 -4.566406 L 5.796875 -20.039062 L 0.78125 -20.039062 L 0.78125 0 Z M 15.773438 0 "
  }))))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    fill: "#18307b",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.15641, 26.564936)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 5.796875 0 L 5.796875 -20.039062 L 0.78125 -20.039062 L 0.78125 0 Z M 5.796875 0 "
  }))))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    fill: "#18307b",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(23.735451, 26.564936)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 15.652344 0 L 15.652344 -4.566406 L 6.367188 -4.566406 L 15.652344 -16.101562 L 15.652344 -20.039062 L 0.601562 -20.039062 L 0.601562 -15.441406 L 9.972656 -15.441406 L 0.601562 -3.875 L 0.601562 0 Z M 15.652344 0 "
  }))))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    fill: "#18307b",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(39.987789, 26.564936)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 15.652344 0 L 15.652344 -4.566406 L 6.367188 -4.566406 L 15.652344 -16.101562 L 15.652344 -20.039062 L 0.601562 -20.039062 L 0.601562 -15.441406 L 9.972656 -15.441406 L 0.601562 -3.875 L 0.601562 0 Z M 15.652344 0 "
  }))))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    fill: "#18307b",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(56.240131, 26.564936)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 16.460938 -15.441406 L 16.460938 -20.039062 L 10.453125 -20.039062 L 10.453125 -12.316406 L 6.457031 -12.316406 L 6.457031 -20.039062 L 0.449219 -20.039062 L 0.449219 -15.441406 L 1.441406 -15.441406 L 1.441406 -7.902344 L 5.949219 -7.902344 L 5.949219 0 L 10.964844 0 L 10.964844 -7.902344 L 15.472656 -7.902344 L 15.472656 -15.441406 Z M 16.460938 -15.441406 "
  }))))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.013641, 52.579785)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 15.480469 -15.421875 L 15.480469 -20.011719 L 0.449219 -20.011719 L 0.449219 -15.421875 L 5.488281 -15.421875 L 5.488281 0 L 10.5 0 L 10.5 -15.421875 Z M 15.480469 -15.421875 "
  }))))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.943621, 52.579785)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 15.808594 0 L 12.871094 -5.578125 L 15.808594 -5.578125 L 15.808594 -20.011719 L 0.78125 -20.011719 L 0.78125 0 L 5.789062 0 L 5.789062 -5.578125 L 7.949219 -5.578125 L 10.800781 0 Z M 10.800781 -10.140625 L 5.789062 -10.140625 L 5.789062 -15.421875 L 10.800781 -15.421875 Z M 10.800781 -10.140625 "
  }))))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(33.533605, 52.579785)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 15.808594 0 L 15.808594 -20.011719 L 10.800781 -20.011719 L 10.800781 -4.558594 L 5.789062 -4.558594 L 5.789062 -20.011719 L 0.78125 -20.011719 L 0.78125 0 Z M 15.808594 0 "
  }))))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(50.123589, 52.579785)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 15.808594 0 L 15.808594 -20.011719 L 0.78125 -20.011719 L 0.78125 0 Z M 10.800781 -4.558594 L 5.789062 -4.558594 L 5.789062 -15.421875 L 10.800781 -15.421875 Z M 10.800781 -4.558594 "
  }))))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(66.713572, 52.579785)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 15.480469 0 L 15.480469 -20.011719 L 0.449219 -20.011719 L 0.449219 -15.421875 L 1.441406 -15.421875 L 1.441406 0 L 5.460938 0 L 5.460938 -15.421875 L 10.46875 -15.421875 L 10.46875 0 Z M 15.480469 0 "
  }))))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(82.973554, 52.579785)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 15.808594 0 L 15.808594 -7.859375 L 10.800781 -7.859375 L 10.800781 -4.558594 L 5.789062 -4.558594 L 5.789062 -15.421875 L 15.808594 -15.421875 L 15.808594 -20.011719 L 0.78125 -20.011719 L 0.78125 0 Z M 15.808594 0 "
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.ac014f891d42317a609de7191d409c2e.svg";
export { ForwardRef as ReactComponent };